import React, { Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  LeadAssignmentSettings,
  AccountType,
} from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { Multiselect } from "react-widgets";
import {
  convertPascalCaseToWords,
  LeadActivitySettingsData,
} from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: LeadActivitySettingsData) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: LeadActivitySettingsData;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<LeadActivitySettingsData>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderRequestCallback = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Request A Callback<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="requestACallBack"
                defaultValue={props.data?.requestACallBack}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "BusinessDeveloperExecutive" : key === "Agent" ?
                            "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.requestACallBack && (
                <ErrorMessage> User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderShowroomVisit = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Schedule Site Visit<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="showroomVisit"
                defaultValue={props.data?.showroomVisit}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "BusinessDeveloperExecutive" : key === "Agent" ?
                            "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.showroomVisit && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderScheduleTestDrive = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Schedule Test Drive<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="testDrive"
                defaultValue={props.data?.testDrive}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.showroomVisit && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderOtherActivity = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Other Activity<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="otherActivity"
                defaultValue={props.data?.otherActivity}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ?
                          "BusinessDeveloperExecutive" : key === "Agent" ?
                            "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.otherActivity && (
                <ErrorMessage> User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderDefault = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">Default<span className="text-danger">*</span></label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="default"
                defaultValue={props.data?.default}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.default && (
                <ErrorMessage> User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderNoOfDays = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            No. of days to allow backdated activity
          </label>
          <Controller
            control={control}
            rules={{
              // required: 'No. of days is required',
              validate: {
                numberOnly: (value) =>
                  !value || new RegExp("\\d+").test(value) || "Invalid number",
              },
            }}
            name="noOfDaysToAllowBackdatedActivity"
            defaultValue={props.data?.noOfDaysToAllowBackdatedActivity}
            render={({ onChange, value, name }) => (
              <input
                type="number"
                min={0}
                className="form-control rounded-sm font-weight-semibold"
                placeholder="No. of days"
                name={name}
                value={value}
                onChange={onChange}
                id="noOfDaysToAllowBackdatedActivity"
              />
            )}
          />
          <ErrorMessage>
            {errors.noOfDaysToAllowBackdatedActivity?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderCustomerAvailableInShowroomOption = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <Controller
            control={control}
            name="isCustomerAvailableInShowroomRequiredForTestDrive"
            defaultValue={
              props.data?.isCustomerAvailableInShowroomRequiredForTestDrive
            }
            render={({ onChange, value, name }) => (
              <Fragment>
                <input
                  type="checkbox"
                  id={name}
                  checked={value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={name}>
                  Is customer available in showroom option required for
                  TestDrive?
                </label>
              </Fragment>
            )}
          />
          <ErrorMessage>
            {errors.isCustomerAvailableInShowroomRequiredForTestDrive?.message}
          </ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Lead Activity Settings
        </h4>
        <div className="row gutter-10">
          {renderRequestCallback()}
          {renderShowroomVisit()}
          {/* {renderScheduleTestDrive()} */}
          {renderOtherActivity()}
          {renderNoOfDays()}
          {/* {renderCustomerAvailableInShowroomOption()} */}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
